import React, { useState } from 'react';
import { Formik } from 'formik';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useDialogsContext } from '../../../contexts/Dialog';
import { useLinesContext } from '../../../contexts/Lines';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { submitNewApplication, pathname } from '../../../utils';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import messages from '../../../messages';
import ContentContainer from '../../BuildingBlocks/Container/ContentContainer';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import * as yup from 'yup';
import ApplicationDetails from './ApplicationDetails';
import ApplicationEditDetails from './ApplicationEditDetails';
import ExistingPlan from './ExistingPlan';
import NextButton from '../NextButton';
import Comment from '../../BuildingBlocks/Text/Comment';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(1.5),
    border: 10,
    position: 'relative',
  },
  div: {
    border: 3,
    padding: 0.5,
  },
  edit: {
    display: 'inline-block',
    margin: 'right',
  },
  icon: {
    position: 'absolute',
    right: 0,
  },
}));

function getExistingPlan() {
  const url = new URLSearchParams(window.location.search);
  const planId = url.get('plan');
  const planName = url.get('planname');
  return { id: planId, name: planName };
}

export default function Review({ lines, business, setBusiness, setLoading }) {
  const dialogs: any = useDialogsContext();
  const snackbar = useSnackbarContext();
  const history = useHistory();
  const classes = useStyles();
  const [editApplicationSection, setEditApplicationSection] = useState(
    business?.name ? false : true,
  );
  const [customerMessage, setCustomerMessage] = useState(null);
  const { trackEvent } = useEventTrackerContext();
  const { lines: allLines, setLines, setApplications } = useLinesContext();
  const existingPlan = getExistingPlan();

  const onCommentChange = (e) => {
    e.preventDefault();
    setCustomerMessage(e.target.value);
  };

  async function handleSubmit() {
    setLoading(true);
    if (editApplicationSection)
      snackbar.show('Must save before submit', 'error');
    else
      try {
        await submitNewApplication(
          lines,
          business,
          customerMessage,
          existingPlan.id,
          trackEvent,
        );
        setLines(null);
        history.push(pathname.submitApplication.url);
        dialogs.open('applicationSubmitted');
        setApplications(null);
      } catch (e) {
        const errorMessage =
          e.error === 'HANDLE_BY_ADMIN'
            ? e.message
            : messages.submitApplication.errors.submit;
        snackbar.show(errorMessage, 'error');
      }
    setLoading(false);
  }

  const linesInApplication = allLines?.filter((line) =>
    lines.includes(line.id),
  );
  const products = [
    ...new Set(linesInApplication?.map((line) => line.product)),
  ];

  return (
    <Formik
      initialValues={{
        businessName: business.name || '',
      }}
      validationSchema={yup.object({
        businessName: yup.string().required('Business Name is required'),
      })}
      onSubmit={handleSubmit}
      component={({ values, submitForm }) => {
        return (
          <ContentContainer width={800}>
            {existingPlan?.name && (
              <ExistingPlan planName={existingPlan.name} />
            )}
            <Paper className={classes.paper} elevation={10}>
              <div className={classes.div}>
                {!editApplicationSection && (
                  <IconButton
                    className={classes.icon}
                    aria-label="edit"
                    onClick={() => {
                      setEditApplicationSection(!editApplicationSection);
                    }}
                  >
                    <EditIcon className={classes.edit} />
                  </IconButton>
                )}

                {editApplicationSection ? (
                  <ApplicationEditDetails
                    business={business}
                    setBusiness={setBusiness}
                    setLoading={setLoading}
                    values={values}
                    setEditClose={setEditApplicationSection}
                  />
                ) : (
                  <ApplicationDetails business={business} />
                )}
              </div>
            </Paper>
            <Paper className={classes.paper} elevation={10}>
              <div className={classes.div}>
                <IconButton
                  className={classes.icon}
                  aria-label="edit"
                  onClick={() => {
                    history.push(pathname.lines.url);
                  }}
                >
                  <EditIcon className={classes.edit} />
                </IconButton>
                <div>
                  <Typography variant="h6" align="justify" gutterBottom>
                    <b> lines : </b> {lines.length} <br />
                  </Typography>
                  <Typography variant="h6" align="justify">
                    <b> Products : </b> {products.length}
                  </Typography>
                </div>
              </div>
            </Paper>
            <Comment
              commentId={'comment'}
              placeholder={'Include a comment with your application (optional)'}
              maxLength={256}
              defaultValue={customerMessage}
              onChangeFunc={onCommentChange}
            />
            <NextButton onClick={submitForm} isFinalStep={true} />
          </ContentContainer>
        );
      }}
    />
  );
}
